<template>
	<div class="leaveExe_bc">
		<div class="leaveExe_body">
			<!-- 按钮 -->
			<img
				src="./../../mycomponents/img/dialog/icon_syt_gb01@2x.png"
				alt=""
				@click="closeLimit()"
			/>
			<!-- 内容 -->
			<p>{{ $t("reminder") }}</p>
			<p>{{ $t("text015") }}</p>
			<!-- 按钮 -->
			<div class="leaveEXE_button">
				<div @click="closeLimit()">{{ $t("cancel") }}</div>
				<div @click="closeExe()">{{ $t("determine") }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "leaveExe",
	methods: {
		closeLimit(flag) {
			this.$emit("close", flag);
		},
		closeExe() {
			window.close();
		},
	},
};
</script>

<style lang="less">
.leaveExe_bc {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 9998;
	background: rgba(0, 0, 0, 0.4);
	display: flex;
	// display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	.leaveExe_body {
		display: flex;
		align-items: center;
		position: absolute;
		width: 360rem;
		height: 201rem;
		background: #ffffff;
		opacity: 1;
		z-index: 9999;
		flex-direction: column;
		border-radius: 8rem;
		img {
			width: 24rem;
			height: 30rem;
			position: absolute;
			top: 0;
			right: 4rem;
			cursor: pointer;
		}
		p {
			display: block;
			font-size: 14rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #5c7099;
			opacity: 1;
			// width: 100%;
			&:nth-of-type(1) {
				margin-top: 39rem;
				margin-bottom: 18rem;
			}
		}
		.leaveEXE_button {
			div {
				width: 110rem;
				height: 35rem;
				background: #006de0;
				opacity: 1;
				margin-top: 38rem;
				font-size: 16rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #ffffff;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				border-radius: 15rem;
				// flex-direction: column;
				border: 1rem solid #006de0;
				&:nth-of-type(1) {
					background: white;
					border: 1rem solid #5c7099;
					color: #5c7099;
					margin-right: 19rem;
					&:hover {
						background-color: rgb(238, 238, 238);
					}
					&:active {
						background-color: rgb(204, 202, 202);
					}
				}
				&:nth-of-type(2):hover {
					background-color: rgba(16, 129, 248, 1);
				}
				&:nth-of-type(2):active {
					background-color: rgba(0, 100, 206, 1);
				}
			}
		}
	}
}
</style>
